export default {
  title: '连娱宝'
}
